// extracted by mini-css-extract-plugin
export var closed = "_ak-1";
export var resizer = "_ak-0";